import { render, staticRenderFns } from "./PartsCatalog.vue?vue&type=template&id=a05127de"
import script from "./PartsCatalog.vue?vue&type=script&lang=js"
export * from "./PartsCatalog.vue?vue&type=script&lang=js"
import style0 from "./PartsCatalog.vue?vue&type=style&index=0&id=a05127de&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports